import initializeComponent from 'Shared/react-initialize';
import {
   TimeDelayNewsletterModal,
   ScrollPercentageNewsletterModal,
} from '@ifixit/ui/newsletter-modal/index';

initializeComponent('TimeDelayNewsletterModalComponent', TimeDelayNewsletterModal);

initializeComponent('ScrollPercentageNewsletterModal', ScrollPercentageNewsletterModal);
